// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

body {
  margin: 0;
  font-family: 'Avenir Light', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
}

#root {
  flex: 1 1;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Avenir Bold', sans-serif !important;
  /* Use Avenir Bold for headers */
}

h1 {
  font-size: 55px;
}

h2 {
  font-size: 42px;

}

h3 {
  font-size: 30px !important;
}

h4 {
  font-size: 24px !important;
}

p {
  font-family: 'Avenir Light', sans-serif !important;
  /* Use Avenir Light for body text */
  font-size: 19px;
}

a {
  font-family: 'Avenir Light', sans-serif;
}

.page-title-div {
  display: flex;
  justify-content: center;
  padding-top: 40px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.validate-page {
  min-height: 900px !important;
}

.page-title {
  font-family: 'Avenir Black', sans-serif !important;
  color: rgb(255, 255, 255);
  font-size: 80px;
  text-shadow: 4px 4px 9px rgba(0, 0, 0, 0.8);
  max-width: 1100px;

}





.custom-links {
  text-decoration: none;
  color: rgb(155, 56, 56);

}

.bulliedbrain {
  text-decoration: none;
  color: #00637C !important;
  font-weight: 900 !important;
  transition: all .2s ease-in-out !important;

}

.bulliedbrain:hover {
  text-decoration: none;
  color: #00637C !important;
  font-weight: 900 !important;
  transform: scale(1.1) !important;
}

.custom-links:hover {
  text-decoration: none;
  color: rgb(155, 56, 56);

}

.default-div {
  max-width: 800px;


  margin: 0 auto;

  padding: 20px;

  font-family: 'Avenir Light', sans-serif;
  /* Choose a suitable font */

  /* Adjust the font size as needed */
  line-height: 1.5;
  /* Set the line height for better readability */
  color: #333;
  /* Set the text color */
  background-color: #f8f8f8dd;
  /* Set a light background color */
  border-radius: 8px;
  /* Add rounded corners */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
  /* Add a subtle box shadow */

  margin-top: 100px;
}

.congrats-div {
  /* max-width: 900px;
  min-width: 900px; */
  width: 100%;
  margin: 0 auto;

  padding: 20px;

  font-family: 'Avenir Light', sans-serif;
  /* Choose a suitable font */

  /* Adjust the font size as needed */
  line-height: 1.5;
  /* Set the line height for better readability */
  color: #333;
  /* Set the text color */
  background-color: #f8f8f8dd;
  /* Set a light background color */
  border-radius: 8px;
  /* Add rounded corners */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
  /* Add a subtle box shadow */

  margin-top: 0px;
  margin-bottom: 70px;
}



footer {

  background-color: #c1c1c1;
  padding: 15px;
  text-align: center;
  font-family: 'Avenir Light', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.mobile-btn-lang {
  background-color: #FF3131 !important;
  color: whitesmoke;
  border: none;

  border-radius: 5px;
  margin: 2px;
  transition: all.2s ease-in-out;
  font-size: 18px;
  cursor: pointer !important;
}





.lang-button-div {
  position: absolute;
  /* background-color: #FF3131 !important; */
  color: whitesmoke;
  border: none;
  min-width: 160px;
  border-radius: 5px;
  top: 15px;
  right: 18px;
  transition: all.2s ease-in-out;
  font-size: 18px !important;
  cursor: pointer !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 75px;
}

.lang-button-div:hover {
  position: absolute;

  /* transform: scale(1.15); */
}

.signOut-btn {
  position: absolute;

  background-color: #FF3131 !important;
  color: whitesmoke;
  border: none;
  top: -65px;
  left: -153px;
  min-width: 160px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;

  transition: all.2s ease-in-out;
}

.signOut-btn:hover {
  position: absolute;

  /* transform: scale(1.15); */

}


@media screen and (max-width: 768px) {
  .default-div {
    max-width: 600px;

    margin: 0 auto;

    padding: 20px;

    font-family: 'Avenir Light', sans-serif;
    /* Choose a suitable font */

    /* Adjust the font size as needed */
    line-height: 1.5;
    /* Set the line height for better readability */
    color: #333;
    /* Set the text color */
    background-color: #f8f8f8dd;
    /* Set a light background color */
    border-radius: 8px;
    /* Add rounded corners */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    /* Add a subtle box shadow */

    margin-top: 60px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .page-title {
    font-family: 'Avenir Black', sans-serif !important;
    color: rgb(255, 255, 255);
    font-size: 40px;
    text-shadow: 4px 4px 9px rgba(0, 0, 0, 0.8);
    margin-left: 20px;
    margin-right: 20px;
  }

  .lang-button-div {
    position: absolute;
    /* background-color: #FF3131 !important; */
    color: whitesmoke;
    border: none;
    margin-top: 20px;
    border-radius: 5px;
    top: -2px;
    right: 18px;
    transition: all.2s ease-in-out;
    font-size: 16px;
    scale: .95;

  }

  .signOut-btn {
    position: absolute;
    background-color: #FF3131 !important;
    color: whitesmoke;
    border: none;

    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    scale: .95;

    right: 18px;
    top: -65px;
    left: -153px;
    min-width: 160px;
  }

  .mobile-btn-lang {
    margin-top: 2px;
    margin-bottom: 2px;
  }

}

@media screen and (max-width: 425px) {
  .mobile-btn-lang {
    margin-top: 2px;
    margin-bottom: 2px;
  }
  h1 {
    font-size: 50px;
  }

  .default-div {
    max-width: 600px;

    margin: 0 auto;

    padding: 20px;

    font-family: 'Avenir Light', sans-serif;
    /* Choose a suitable font */

    /* Adjust the font size as needed */
    line-height: 1.5;
    /* Set the line height for better readability */
    color: #333;
    /* Set the text color */
    background-color: #f8f8f8dd;
    /* Set a light background color */
    border-radius: 8px;
    /* Add rounded corners */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    /* Add a subtle box shadow */

    margin-top: 50px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .page-title {
    font-family: 'Avenir Black', sans-serif !important;
    color: rgb(255, 255, 255);
    font-size: 40px;
    text-shadow: 4px 4px 9px rgba(0, 0, 0, 0.8);
    margin-left: 20px;
    margin-right: 20px;
  }

  .lang-button-div {
    position: absolute;
    /* background-color: #FF3131 !important; */
    color: whitesmoke;
    border: none;
    margin-top: 20px;
    border-radius: 5px;
    top: -2px;
    right: -5px;
    transition: all.2s ease-in-out;
    font-size: 16px;
    scale: .75;
    min-width: 120px;

  }

  .signOut-btn {
    position: absolute;
    background-color: #FF3131 !important;
    color: whitesmoke;
    border: none;

    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    scale: .75;

    right: 0px;
    top: -65px;
    left: -115px;
    min-width: 145px;
  }

}



.certificate {
  width: 500px;
  /* Adjust width as needed */
  height: 300px;
  /* Adjust height as needed */
  /* Add other styles like border, margin, etc. */
}

/* Amplify CSS properties for customization */
.amplify-button {
  background-color: #FF3131 !important;
  color: whitesmoke !important;
  box-shadow: #333 0px 0px 1px !important;
}

.amplify-button--link {
  color: white !important;
}

.amplify-tabs-item {
  color: #333 !important;
}

.amplify-tabs-item:active {
  border-color: #FF3131 !important;
}

.amplify-tabs-item[data-state=active] {
  border-color: #FF3131 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;EAME,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;EACzB,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;;AAEnB;;;;;;AAMA;EACE,qBAAqB;EACrB,uBAAuB;;AAEzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;;AAE5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;;AAEzB;;AAEA;EACE,gBAAgB;;;EAGhB,cAAc;;EAEd,aAAa;;EAEb,uCAAuC;EACvC,2BAA2B;;EAE3B,mCAAmC;EACnC,gBAAgB;EAChB,+CAA+C;EAC/C,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;EACvC,4BAA4B;;EAE5B,iBAAiB;AACnB;;AAEA;EACE;qBACmB;EACnB,WAAW;EACX,cAAc;;EAEd,aAAa;;EAEb,uCAAuC;EACvC,2BAA2B;;EAE3B,mCAAmC;EACnC,gBAAgB;EAChB,+CAA+C;EAC/C,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;EACvC,4BAA4B;;EAE5B,eAAe;EACf,mBAAmB;AACrB;;;;AAIA;;EAEE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;;EAEZ,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;AAC5B;;;;;;AAMA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;;EAElB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;;EAElB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;;EAEf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;;EAElB,4BAA4B;;AAE9B;;;AAGA;EACE;IACE,gBAAgB;;IAEhB,cAAc;;IAEd,aAAa;;IAEb,uCAAuC;IACvC,2BAA2B;;IAE3B,mCAAmC;IACnC,gBAAgB;IAChB,+CAA+C;IAC/C,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,uCAAuC;IACvC,4BAA4B;;IAE5B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kDAAkD;IAClD,yBAAyB;IACzB,eAAe;IACf,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,UAAU;;EAEZ;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;;IAEZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,UAAU;;IAEV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;;IAEhB,cAAc;;IAEd,aAAa;;IAEb,uCAAuC;IACvC,2BAA2B;;IAE3B,mCAAmC;IACnC,gBAAgB;IAChB,+CAA+C;IAC/C,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,uCAAuC;IACvC,4BAA4B;;IAE5B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kDAAkD;IAClD,yBAAyB;IACzB,eAAe;IACf,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,gBAAgB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;;IAEZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,UAAU;;IAEV,UAAU;IACV,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;AAEF;;;;AAIA;EACE,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["html,\nbody {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Avenir Light', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: flex;\n  flex-direction: column;\n}\n\n#root {\n  flex: 1;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Avenir Bold', sans-serif !important;\n  /* Use Avenir Bold for headers */\n}\n\nh1 {\n  font-size: 55px;\n}\n\nh2 {\n  font-size: 42px;\n\n}\n\nh3 {\n  font-size: 30px !important;\n}\n\nh4 {\n  font-size: 24px !important;\n}\n\np {\n  font-family: 'Avenir Light', sans-serif !important;\n  /* Use Avenir Light for body text */\n  font-size: 19px;\n}\n\na {\n  font-family: 'Avenir Light', sans-serif;\n}\n\n.page-title-div {\n  display: flex;\n  justify-content: center;\n  padding-top: 40px;\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.validate-page {\n  min-height: 900px !important;\n}\n\n.page-title {\n  font-family: 'Avenir Black', sans-serif !important;\n  color: rgb(255, 255, 255);\n  font-size: 80px;\n  text-shadow: 4px 4px 9px rgba(0, 0, 0, 0.8);\n  max-width: 1100px;\n\n}\n\n\n\n\n\n.custom-links {\n  text-decoration: none;\n  color: rgb(155, 56, 56);\n\n}\n\n.bulliedbrain {\n  text-decoration: none;\n  color: #00637C !important;\n  font-weight: 900 !important;\n  transition: all .2s ease-in-out !important;\n\n}\n\n.bulliedbrain:hover {\n  text-decoration: none;\n  color: #00637C !important;\n  font-weight: 900 !important;\n  transform: scale(1.1) !important;\n}\n\n.custom-links:hover {\n  text-decoration: none;\n  color: rgb(155, 56, 56);\n\n}\n\n.default-div {\n  max-width: 800px;\n\n\n  margin: 0 auto;\n\n  padding: 20px;\n\n  font-family: 'Avenir Light', sans-serif;\n  /* Choose a suitable font */\n\n  /* Adjust the font size as needed */\n  line-height: 1.5;\n  /* Set the line height for better readability */\n  color: #333;\n  /* Set the text color */\n  background-color: #f8f8f8dd;\n  /* Set a light background color */\n  border-radius: 8px;\n  /* Add rounded corners */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n  /* Add a subtle box shadow */\n\n  margin-top: 100px;\n}\n\n.congrats-div {\n  /* max-width: 900px;\n  min-width: 900px; */\n  width: 100%;\n  margin: 0 auto;\n\n  padding: 20px;\n\n  font-family: 'Avenir Light', sans-serif;\n  /* Choose a suitable font */\n\n  /* Adjust the font size as needed */\n  line-height: 1.5;\n  /* Set the line height for better readability */\n  color: #333;\n  /* Set the text color */\n  background-color: #f8f8f8dd;\n  /* Set a light background color */\n  border-radius: 8px;\n  /* Add rounded corners */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n  /* Add a subtle box shadow */\n\n  margin-top: 0px;\n  margin-bottom: 70px;\n}\n\n\n\nfooter {\n\n  background-color: #c1c1c1;\n  padding: 15px;\n  text-align: center;\n  font-family: 'Avenir Light', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n}\n\n.mobile-btn-lang {\n  background-color: #FF3131 !important;\n  color: whitesmoke;\n  border: none;\n\n  border-radius: 5px;\n  margin: 2px;\n  transition: all.2s ease-in-out;\n  font-size: 18px;\n  cursor: pointer !important;\n}\n\n\n\n\n\n.lang-button-div {\n  position: absolute;\n  /* background-color: #FF3131 !important; */\n  color: whitesmoke;\n  border: none;\n  min-width: 160px;\n  border-radius: 5px;\n  top: 15px;\n  right: 18px;\n  transition: all.2s ease-in-out;\n  font-size: 18px !important;\n  cursor: pointer !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 75px;\n}\n\n.lang-button-div:hover {\n  position: absolute;\n\n  /* transform: scale(1.15); */\n}\n\n.signOut-btn {\n  position: absolute;\n\n  background-color: #FF3131 !important;\n  color: whitesmoke;\n  border: none;\n  top: -65px;\n  left: -153px;\n  min-width: 160px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 18px;\n\n  transition: all.2s ease-in-out;\n}\n\n.signOut-btn:hover {\n  position: absolute;\n\n  /* transform: scale(1.15); */\n\n}\n\n\n@media screen and (max-width: 768px) {\n  .default-div {\n    max-width: 600px;\n\n    margin: 0 auto;\n\n    padding: 20px;\n\n    font-family: 'Avenir Light', sans-serif;\n    /* Choose a suitable font */\n\n    /* Adjust the font size as needed */\n    line-height: 1.5;\n    /* Set the line height for better readability */\n    color: #333;\n    /* Set the text color */\n    background-color: #f8f8f8dd;\n    /* Set a light background color */\n    border-radius: 8px;\n    /* Add rounded corners */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    /* Add a subtle box shadow */\n\n    margin-top: 60px;\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  .page-title {\n    font-family: 'Avenir Black', sans-serif !important;\n    color: rgb(255, 255, 255);\n    font-size: 40px;\n    text-shadow: 4px 4px 9px rgba(0, 0, 0, 0.8);\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .lang-button-div {\n    position: absolute;\n    /* background-color: #FF3131 !important; */\n    color: whitesmoke;\n    border: none;\n    margin-top: 20px;\n    border-radius: 5px;\n    top: -2px;\n    right: 18px;\n    transition: all.2s ease-in-out;\n    font-size: 16px;\n    scale: .95;\n\n  }\n\n  .signOut-btn {\n    position: absolute;\n    background-color: #FF3131 !important;\n    color: whitesmoke;\n    border: none;\n\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    scale: .95;\n\n    right: 18px;\n    top: -65px;\n    left: -153px;\n    min-width: 160px;\n  }\n\n  .mobile-btn-lang {\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\n}\n\n@media screen and (max-width: 425px) {\n  .mobile-btn-lang {\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n  h1 {\n    font-size: 50px;\n  }\n\n  .default-div {\n    max-width: 600px;\n\n    margin: 0 auto;\n\n    padding: 20px;\n\n    font-family: 'Avenir Light', sans-serif;\n    /* Choose a suitable font */\n\n    /* Adjust the font size as needed */\n    line-height: 1.5;\n    /* Set the line height for better readability */\n    color: #333;\n    /* Set the text color */\n    background-color: #f8f8f8dd;\n    /* Set a light background color */\n    border-radius: 8px;\n    /* Add rounded corners */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    /* Add a subtle box shadow */\n\n    margin-top: 50px;\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  .page-title {\n    font-family: 'Avenir Black', sans-serif !important;\n    color: rgb(255, 255, 255);\n    font-size: 40px;\n    text-shadow: 4px 4px 9px rgba(0, 0, 0, 0.8);\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .lang-button-div {\n    position: absolute;\n    /* background-color: #FF3131 !important; */\n    color: whitesmoke;\n    border: none;\n    margin-top: 20px;\n    border-radius: 5px;\n    top: -2px;\n    right: -5px;\n    transition: all.2s ease-in-out;\n    font-size: 16px;\n    scale: .75;\n    min-width: 120px;\n\n  }\n\n  .signOut-btn {\n    position: absolute;\n    background-color: #FF3131 !important;\n    color: whitesmoke;\n    border: none;\n\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    scale: .75;\n\n    right: 0px;\n    top: -65px;\n    left: -115px;\n    min-width: 145px;\n  }\n\n}\n\n\n\n.certificate {\n  width: 500px;\n  /* Adjust width as needed */\n  height: 300px;\n  /* Adjust height as needed */\n  /* Add other styles like border, margin, etc. */\n}\n\n/* Amplify CSS properties for customization */\n.amplify-button {\n  background-color: #FF3131 !important;\n  color: whitesmoke !important;\n  box-shadow: #333 0px 0px 1px !important;\n}\n\n.amplify-button--link {\n  color: white !important;\n}\n\n.amplify-tabs-item {\n  color: #333 !important;\n}\n\n.amplify-tabs-item:active {\n  border-color: #FF3131 !important;\n}\n\n.amplify-tabs-item[data-state=active] {\n  border-color: #FF3131 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
